import React, { useState } from "react";
import Form from "react-bootstrap/Form";
export function ProposalTopics({proposals, topics, loadProposals, configuration}) {
    const [currentTopic, setCurrentTopic] = useState("-1");

    function setTopic(event) {
        let topic_id = event.target.value;
        setCurrentTopic(topic_id);
        if (topic_id.length == 0) topic_id = null;
        loadProposals(topic_id);
    }
    const topicList = topics.map(topic =>
        <option
            key={topic[0]}
            value={topic[0]}
        >
            {topic[1]}
        </option>
    );
    return (
        <div className="d-flex flex-column flex-md-row align-items-center mt-3 mb-3">
            <h4>{configuration.translations.lastProposals}</h4>
            <div className="ms-0 ms-md-auto">
                <div className="row g-3 align-items-center">
                    <div className="col-auto">
                        <label htmlFor="categoryselect" className="col-form-label">{configuration.translations.categoriesTitle}</label>
                    </div>
                    <div className="col-auto">
                        <Form.Select id="categoryselect" onChange={setTopic}>
                            <option value="-1" >{configuration.translations.allCategories}</option>
                            {topicList}
                        </Form.Select>
                    </div>
                </div>
            </div>
        </div>
    )
}
